<script type="text/javascript">
    import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents'

    export default {

        data: function () {
            return {
                paid_amount: 0,
                voucher: null,
                permalink : permalink,
                info: null
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('finish');
        },

        mounted: function () {
            this.$event_bus.$on('finish', (data) => {
                this.info = data.data;
                this.voucher = data.data.voucher;
                this.paid_amount = data.paid_amount;

                if (data.voucher_price) {
                    GoogleAnalyticsEvents.VoucherPurchased.send({
                        'event_category': system_name,
                        'event_label': data.voucher_name,
                        'value': data.voucher_price,
                        'send_to': 'clientTracker',
                    });
                }
            });
        },

        methods: {
            restart() {
                location.reload();
            }
        },
    };


</script>


<template id="booking-success">

    <div class="panel m-b-15 rounded-lg" v-if="voucher" id="booking-success-panel">
        <div class="panel-body" id="booking-success-booking">
            <div class="row">
                <div class="col-xs-12 text-center m-t-40 m-b-30">
                    <i class="zmdi zmdi-check-circle booking-success-icon"></i>
                    <h3 >
                        {{ trans('vouchers.purchase_confirmation.email_subject') }}
                    </h3>
                    <h5 v-if="paid_amount > 0" class="m-b-30" style="line-height: 25px;"> {{ trans('vouchers.purchase_confirmation.payment_accepted') }}. <span v-if="info.email !== ''"><br>{{ trans('vouchers.client_purchase_email', { email: info.email}) }}</span></h5>

                    <a class="btn btn-lg btn-custom btn-trans" :href="'/book/'+permalink" v-if="!voucher.is_for_events">
                        <span class="m-l-10">{{ trans('vouchers.book_first_time') }}</span>
                        <i class="zmdi zmdi-arrow-right m-l-5"></i>
                    </a>
                </div>
            </div>

        </div>
    </div>

</template>
